export const SETTINGS_GROUP_NAME = 'automatic-rostering';

/**
 * Form field names, which are the setting keys with the dots replaced by underscores - see
 * `transformAdminSettingsToFormValues`. Spelled out here rather than derived, so that a rename of a
 * setting key is a compile error in this file instead of a silently empty field in the form.
 */
export const FIELD = {
  ENABLED: 'automatic-rostering_engine_enabled',
  API_KEY: 'automatic-rostering_engine_api-key',
  DEFAULT_FOR_ALL_PLAN_UNITS:
    'automatic-rostering_engine_default_enabled_for_all_planunits'
} as const;
